import { render } from "./SwiftFlexAdvert.vue?vue&type=template&id=61ce7e02&scoped=true"
import script from "./SwiftFlexAdvert.vue?vue&type=script&lang=js"
export * from "./SwiftFlexAdvert.vue?vue&type=script&lang=js"

import "./SwiftFlexAdvert.vue?vue&type=style&index=0&id=61ce7e02&scoped=true&lang=scss"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61ce7e02"]])

export default __exports__